// extracted by mini-css-extract-plugin
export var container = "_fu-0";
export var content = "_fu-3";
export var customerTitle = "_fu-4";
export var empty = "_fu-5";
export var gray = "_fu-6";
export var header = "_fu-7";
export var info = "_fu-8";
export var loading = "_fu-2";
export var loadingCard = "_fu-9";
export var oneLine = "_fu-a";
export var personName = "_fu-e";
export var pillContainer = "_fu-b";
export var selected = "_fu-1";
export var text = "_fu-c";
export var twoLines = "_fu-d";
export var unread = "_fu-f";
export var unreadIndicator = "_fu-g";